<template>
  <div class="users-bg">
    <mainHeader></mainHeader>
    <div class="container">
      <div class="row has-header">
        <div class="col-md-12 col-sm-12 col-xs-12 pb-20 pt-30">
          <div class="col-md-3 col-sm-3 col-xs-3 p-0">
            <div class="col-md-4 col-sm-4 col-xs-12 pl-0">
              <input type="text" class="form-control br-3 search-field" placeholder="Search" data-test="searchInput" v-model="searchTerm" @keyup.enter="searchUserFilterStudies(searchTerm, sort, filter)" />
            </div>
          </div>
          <div class="col-md-9 col-sm-9 col-xs-9 p-0">
            <b-btn variant="primary" class="fs-12 ml-10 bg-4c8ce4 add-icon mt-5 pull-right" @click="addUser()">
              <span class="cursor_pointer mt-5">
                <i class="fa fa-plus fa-stack-1x icon-background-maroon border-radius50"></i>
                <span class="add-text">Add</span>
              </span>
            </b-btn>
            <b-btn variant="primary" v-if="isShowSettings" @click="onSettings()" class="fs-12 ml-10 btn-settings add-icon mt-5 pull-right">
              <span class="cursor_pointer mt-5">
                <span class="add-text"> Settings </span>
              </span>
            </b-btn>
            <div class="col-xs-12 col-sm-4 col-md-2 col-lg-3 pl-0 mt-5">
              <select class="form-control txt-style cursor_pointer box-height br-2" v-model="filter" v-on:change="searchUserFilterStudies(searchTerm, sort, filter)">
                <option class="cursor_pointer" disabled value="default">Filters</option>
                <option class="cursor_pointer" value="default">None</option>
                <option class="cursor_pointer" value="Active">Active</option>
                <option class="cursor_pointer" value="Inactive">Inactive</option>
                <option class="cursor_pointer" value="Pending">Pending</option>
              </select>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-2 col-lg-3 pl-0 mb-10 mt-5">
              <select class="form-control txt-style cursor_pointer box-height br-2" v-model="sort" v-on:change="searchUserFilterStudies(searchTerm, sort, filter)">
                <option class="cursor_pointer" disabled value="default">Sort</option>
                <option class="cursor_pointer" value="default">None</option>
                <option class="cursor_pointer" value="Asc">A-Z</option>
                <option class="cursor_pointer" value="Desc">Z-A</option>
              </select>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-3 col-lg-4 mb-10 mt-12 deactivated-user-toggle">
              <label class="checkbox-label">
                <span class="checkbox-text mr-10">Hide deactivated users</span>
                <input class="hidden-input" type="checkbox" v-model="hideDeactivatedUser" />
                <span class="input-checkbox"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="fs-10 pl-20">NAME</th>
                  <th class="xs-none fs-10 pl-70">EMAIL</th>
                  <th class="xs-none fs-10 padding-left">STATUS</th>
                  <th class="fs-10 pl-198">ACTION</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in users" :key="index" :data-test="'userRow_' + user.id">
                  <td class="text-wrap col-sm-3 col-lg-3 col-md-3 body-text pl-20">{{ user.firstName }} {{ user.lastName }}</td>
                  <td class="xs-none text-wrap col-sm-3 col-lg-3 col-md-3 body-text pl-70">
                    {{ user.username }}
                  </td>
                  <td class="xs-none col-sm-2 col-lg-2 col-md-2 body-text padding-left">
                    {{ user.status }}
                  </td>
                  <td class="view-color col-sm-2 col-lg-2 col-md-2" v-on:click="viewUser(user.id)">
                    <span class="view-btn cursor_pointer">View</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row bottom_footer">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <p class="text-center font-size10 color_top">
            Questions or need help ?
          </p>
          <Copyright />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from "toastr";
import _ from "lodash";
import mainHeader from "../common/main-header";
import Copyright from "../common/copyright";
import "nprogress/nprogress.css";
import { SYSTEM_ADMIN } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";

export default {
  name: "TeamManagement",
  props: {
    doNotShowNoUsersFoundErrorOnFirstSearch: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      id: null,
      users: {},
      searchTerm: null,
      filter: "default",
      sort: "default",
      hideDeactivatedUser: true,
      usersHaveBeenSearch: false
    };
  },
  watch: {
    hideDeactivatedUser() {
      this.searchUserFilterStudies(this.searchTerm, this.sort, this.filter);
    }
  },
  mounted() {
    this.searchUserFilterStudies(this.searchTerm, this.sort, this.filter);
  },
  computed: {
    ...mapGetters(["user"]),
    isShowSettings() {
      return !!this.canSystemAdminAccess;
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSystemAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    }
  },
  methods: {
    searchUserFilterStudies(searchTermOld, sortOld, filterOld) {
      let searchTerm = searchTermOld;
      let sort = sortOld;
      let filter = filterOld;
      if (searchTerm) {
        searchTerm = searchTerm.trim();
        this.searched = searchTerm.length > 0;
      }
      sort = _.cloneDeep(sort === "default" ? null : sort);
      filter = _.cloneDeep(filter === "default" ? null : filter);
      this.$api
        .userSearchFilterFact(this.searchTerm, sort, filter, this.hideDeactivatedUser)
        .then(response => {
          if (response.body) {
            this.users = response.body;
          }
          if (response.body.length === 0) {
            // after creating a user in the component add-edit-user, the router pushes back to this component and the method 'searchUserFilterStudies' is called
            // in story TR02-1614 there is an edge case scenario when a user can add another user but can't not see this newly created user in the users list returned by this endpoint
            // this combination results in the message 'No users found' being shown just after creating a user
            // so, this is to prevent the message 'No users found' to appear as soon as a new user is created
            // the following searches should show the 'No users found' error
            if (!this.doNotShowNoUsersFoundErrorOnFirstSearch || this.usersHaveBeenSearch) {
              toastr.error("No users found");
            }
          }
        })
        .finally(() => {
          this.usersHaveBeenSearch = true;
        });
    },
    viewUser(userId) {
      this.$router.push({ name: "add-edit-user", params: { userId } });
    },
    addUser() {
      this.$router.push({ name: "add-edit-user", params: { userId: 0 } });
    },
    onSettings() {
      this.$router.push({
        name: "users-deactivation-settings",
        params: { clientId: this.user.clientId }
      });
    }
  },
  components: { mainHeader, Copyright }
};
</script>

<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss">
// Style for quick fixes bootstrap after migration (before redesign should be removed)

body {
  color: #333;
}

.h2,
h2 {
  font-size: 30px;
  margin: 20px 0 10px;
}

.h3,
h3 {
  font-size: 24px;
  color: #333;
}

.h4,
h4 {
  font-size: 18px;
  margin: 10px 0;
}

.h5,
h5 {
  font-size: 14px;
  margin: 10px 0;
}

.h6,
h6 {
  font-size: 12px;
  margin: 10px 0;
  color: #333;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-xs-10 {
  width: 83.33333333%;
}

.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.search-field {
  padding-right: 30px;
  background-image: url("/static/img/search-icon-light.png");
  background-repeat: no-repeat;
  background-position: 97% 50%;
  width: 305px;
  height: 40px;
  border-radius: 3px;
  border: solid 2px #d3dfe4;
}

table td[class*="col-"],
table th[class*="col-"] {
  position: static;
  display: table-cell;
  float: none;
}

table {
  table-layout: fixed;
  background-color: #fff !important;
}

.table > thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #ddd;
}

@media (min-width: 768px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: right;
    display: block;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    // float: left;
    flex: none;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-12 {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: right;
    display: block;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
}

@media (min-width: 1024px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: right;
    display: block;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
}
// END of style for quick fixes bootstrap after migration (before redesign should be removed)

.users-bg {
  min-height: 100vh;
  background-color: #f5f8fa;
  background-blend-mode: soft-light;
  height: 100%;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.icon-background-maroon {
  height: 20px;
  left: 6px;
  top: 5px;
  color: #4c8ce4 !important;
  width: 22px;
  background: #fff !important;
  border-radius: 3px;
  padding-top: 2px;
}

.border-radius50 {
  border-radius: 3px;
}

h1,
h2 {
  font-weight: 0px;
  font-family: Helvetica;
}

h3 {
  padding-bottom: 60px;
  color: black;
}

.panel-body {
  min-height: 200px;
  height: 200px;
}

.heading {
  font-size: 24px;
  font-weight: 200;
}

.header_row {
  padding-bottom: 20px;
}

.fontStyle {
  font-family: sans-serif;
  font-size: 4rem;
  margin-bottom: 50px;
  margin-top: 10px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #fff;
  text-decoration: none;
  font-size: 25px;
}

.date_val {
  color: #aaa;
  font-size: 12px;
}

button {
  cursor: pointer;
}

.outline-active {
  background: none;
  border: 1px solid #01b7fe;
  color: #01b7fe;
}

.outline-inactive {
  background: none;
  border: 1px solid #8c8c8c;
  color: #8c8c8c;
}

p {
  font-size: 15px;
}

.study-card {
  background-color: #f5f8fa;
  border: none !important;
  padding: 10px 10px 10px 10px;
}

.new-card {
  background-color: #01b7fe;
  text-align: center;
  height: 200px;
  padding-top: 80px;
}

.bottom_footer {
  position: relative;
  bottom: 0px;
  width: 100%;
  padding-top: 20px;
  color: #fff;
  clear: both;
}

.header {
  padding-top: 20px;
  padding-bottom: 10px;
}

.user-icon {
  padding-right: 10px;
  color: yellow;
}

.font-size10 {
  font-size: 10px;
  margin: 0px !important;
}

.logout_link {
  line-height: 12px;
  font-size: 14px;
}

.team-member {
  font-size: 30px;
  line-height: 1.87;
}

.search-pad {
  padding: 5px 10px;
}

.select-style {
  background: rgba(22, 59, 78, 0.7);
}

.search-color {
  color: #333;
}
.select_control {
  background-repeat: no-repeat;
  background-color: #d3dfe4;
  padding: 0 10px !important;
  border: none;
  background-image: none !important;
  height: 34px !important;
}

table {
  color: #4a4a4a;
  td,
  th {
    width: auto !important;
    padding: 8px !important;
  }
}

td {
  border: none !important;
}

th {
  color: #959fa4;
  height: 42px !important;
}

.text-wrap {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 767px) {
  .xs-none {
    display: none;
  }
}

.view-btn {
  width: 66px;
  height: 30px;
  padding: 3px 12px 3px 12px;
  border-radius: 3px;
  border: solid 2px #d3dfe4;
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4c8ce4;
  margin-left: 190px;
  opacity: 0.7;
}

.body-text {
  width: 112px;
  height: 16px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #666669;
}

.padding-left {
  padding-left: 140px !important;
}

.pl-198 {
  padding-left: 198px !important;
}

.pl-70 {
  padding-left: 70px !important;
}

.select_white {
  width: 135px;
  height: 32.7px;
  border-radius: 3px;
  border: solid 2px #d3dfe4;
  background: #fff;
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #666669;
}

.search {
  width: 305px;
  height: 34px;
  border-radius: 3px;
  border: solid 2px #d3dfe4;
  margin-left: 12px;
}
.add-btn {
  width: 84px;
  height: 33px;
  border-radius: 4px;
  border: solid 1px #4c8ce4;
  background-color: #4c8ce4;
  font-size: 14px;
}

.pl-20 {
  padding-left: 20px !important;
}

span.btn-text {
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: -7.57;
  letter-spacing: normal;
  color: #ffffff;
  padding-left: 45px;
  position: absolute;
  top: 2px;
  right: 14px;
}

.box-height {
  height: 33px !important;
}

.txt-style {
  font-family: Roboto-Regular;
  font-size: 13px;
  color: #666669;
}
.add-text {
  float: right;
}
.add-icon {
  width: 70px;
  position: relative;
}
.bg-4c8ce4 {
  background-color: #4c8ce4 !important;
  border: #4c8ce4 !important;
}
.color_top {
  color: #666669;
}
.btn-settings {
  border: solid 1px#c5d1d6;
  color: #4c8ce4;
  background-color: #fff;
  &:hover {
    color: #4c8ce4;
  }
}
.deactivated-user-toggle {
  text-align: right;
  .checkbox-label {
    position: relative;
    margin-bottom: 8px;
    cursor: pointer;
    margin-right: 22px;
    .checkbox-text {
      font-size: 14px;
      color: #9b9b9b;
      font-family: Roboto-Regular;
    }
  }
  .checkbox-label input {
    opacity: 0;
    position: absolute;
    cursor: pointer;
    z-index: 999;
    width: 18px;
    height: 19px;
    margin-left: -9px;
  }
  .input-checkbox {
    position: absolute;
    top: 0px;
    height: 20px;
    width: 20px;
    background-color: #fff;
    border-radius: 2px;
    border: 1.5px solid #959fa4;
  }
  .input-checkbox::after {
    position: absolute;
    content: "";
    top: 12px;
    left: 12px;
    height: 0px;
    width: 0px;
    background-color: transparent;
    border-radius: 5px;
    border: solid #ffffff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(0deg) scale(0);
    -ms-transform: rotate(0deg) scale(0);
    transform: rotate(0deg) scale(0);
    opacity: 1;
  }
  .checkbox-label input:checked ~ .input-checkbox {
    background-color: #1e8fe1;
    border-radius: 2px;
    -webkit-transform: rotate(0deg) scale(1);
    -ms-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
    opacity: 1;
    border: 1.5px solid #1e8fe1;
  }
  .checkbox-label input:checked ~ .input-checkbox:after {
    -ms-transform: rotate(45deg) scale(1);
    transform: rotate(45deg) scale(1);
    opacity: 1;
    left: 6px;
    top: 1px;
    width: 6px;
    height: 12px;
    border: solid #ffffff;
    border-width: 0px 2px 2px 0px;
    background-color: transparent;
    border-radius: 0;
  }
}
</style>
